import React from 'react';
import { ArrowRight } from 'lucide-react';
import Reveal from './Reveal';
import { EMAIL_DESIGNS } from '../mock';

function EmailFrame({ email }) {
  return (
    <div className="ob-email-card relative mx-3 w-72 shrink-0 overflow-hidden rounded-2xl bg-white sm:w-80 md:w-[348px]">
      {/* Standardized window: taller visible portion so the actual design reads,
          consistent widths, cropped via overflow (source untouched) */}
      <div className="h-[620px] w-full overflow-hidden md:h-[740px]">
        <img
          src={email.src}
          alt={email.alt}
          loading="lazy"
          draggable={false}
          className="block w-full"
        />
      </div>
      {/* subtle fade so the crop reads as an intentional frame */}
      <div className="pointer-events-none absolute inset-x-0 bottom-0 h-16 bg-gradient-to-t from-white to-transparent" />
    </div>
  );
}

function Row({ items, direction, duration }) {
  const loop = [...items, ...items, ...items];
  return (
    <div className="ob-marquee-wrap ob-fade-x overflow-hidden">
      <div
        className={`ob-marquee ${direction === 'right' ? 'ob-marquee--right' : 'ob-marquee--left'}`}
        style={{ animationDuration: `${duration}s` }}
      >
        {loop.map((e, i) => (
          <EmailFrame key={`${e.id}-${i}`} email={e} />
        ))}
      </div>
    </div>
  );
}

export default function EmailPortfolio() {
  const d = EMAIL_DESIGNS;
  // Two distinct orderings for visual variety across the opposing rows
  const rowA = [d[0], d[4], d[1], d[5], d[3], d[6], d[2]];
  const rowB = [d[6], d[2], d[5], d[0], d[3], d[1], d[4]];
  return (
    <section id="work" className="ob-dark-section overflow-hidden bg-[var(--ob-dark)] py-20 md:py-24">
      <div className="mx-auto max-w-[1280px] px-5 md:px-8">
        <Reveal className="mb-12 max-w-2xl">
          <p className="mb-4 text-xs font-semibold uppercase tracking-[0.2em] text-[var(--ob-accent)]">
            The Design Studio
          </p>
          <h2 className="font-display text-4xl font-extrabold tracking-tight text-white md:text-6xl">
            See our high-converting email designs.
          </h2>
          <p className="mt-5 text-lg text-white/60">
            Real OnBrand creative: clean, modern, mobile-first and engineered to sell.
          </p>
        </Reveal>
      </div>

      <div className="flex flex-col gap-5">
        <Row items={rowA} direction="left" duration={55} />
        <Row items={rowB} direction="right" duration={65} />
      </div>

      <div className="mx-auto mt-12 max-w-[1280px] px-5 text-center md:px-8">
        <Reveal>
          <a
            href="https://calendly.com/hello-onbrandadmin/30min" target="_blank" rel="noopener noreferrer"
            className="ob-btn group inline-flex items-center gap-2 rounded-full bg-[var(--ob-accent)] px-9 py-[1.15rem] text-lg font-bold text-[var(--ob-dark)] hover:bg-white"
          >
            Book A Free Call
            <ArrowRight size={20} className="transition-transform group-hover:translate-x-1" />
          </a>
        </Reveal>
      </div>
    </section>
  );
}
